import { Stack } from '@mui/material'

export const Send = () => {
    return (
        <Stack sx={{ p: 3 }} spacing={3}>
            Send
        </Stack>
    )
}
